import React, { FC } from 'react';

import { LeftProgressBar, ProgressBarContainer, ProgressBarsContainer, RightProgressBar } from './styles';

type Props = {
    awayTeamColor: string;
    awayTeamValue?: number;
    homeTeamColor: string;
    homeTeamValue?: number;
};

const ProgressBar: FC<Props> = ({ awayTeamColor, awayTeamValue = 0, homeTeamColor, homeTeamValue = 0 }) => {
    // If both values are 0, then we will divide the space evenly for both progress bars
    const total = awayTeamValue + homeTeamValue;
    const formattedAwayValue = total === 0 ? 1 : awayTeamValue / total;
    const formattedHomeValue = total === 0 ? 1 : homeTeamValue / total;
    return (
        <ProgressBarsContainer>
            <ProgressBarContainer $isHidden={formattedAwayValue === 0} $value={formattedAwayValue}>
                <LeftProgressBar $color={awayTeamColor} />
            </ProgressBarContainer>
            <ProgressBarContainer $isHidden={formattedHomeValue === 0} $value={formattedHomeValue}>
                <RightProgressBar $color={homeTeamColor} />
            </ProgressBarContainer>
        </ProgressBarsContainer>
    );
};

export default ProgressBar;
